<template>
  <button
    v-if="status.isSelectable || value.selected"
    class="shop-product-card"
    :class="{
      'shop-product-card--selected': selected,
    }"
    v-on="$listeners"
  >
    <div v-if="selected" class="shop-product-card--selected-icon">
      <FontAwesomeIcon :icon="['fas', 'check']" />
    </div>
    <div class="shop-product-card__image">
      <img :src="image" v-if="showImage && image" />
      <FontAwesomeIcon v-if="!image" :icon="['fal', 'box-alt']" size="lg" />
    </div>

    <div class="shop-product-card__content">
      <div class="shop-product-card__name">{{ value.product.name }}</div>
      <div class="shop-product-card__properties">
        <div
          v-if="!value.isDummy && !hidePrice"
          class="shop-product-card__price shop-product-card__property"
        >
          <span v-if="value.isDefault">{{ $t('default') }}</span>
          <span v-else-if="[null, undefined].includes(value.product.gross)">
            {{ $t('priceOnRequest') }}</span
          >
          <template v-else>
            <FontAwesomeIcon :icon="['fal', 'tag']" />
            <span> {{ value.product.gross | Currency }}</span></template
          >
        </div>
        <div v-if="set" class="shop-product-card__set shop-product-card__property">
          <FontAwesomeIcon :icon="['fal', 'box-alt']" />
          <span>{{ set.name }}</span>
        </div>
      </div>
    </div>

    <slot name="actions" />
    <div v-if="selected && !status.isUnselectable" class="shop-product-card__icon">
      <FontAwesomeIcon :icon="['fas', 'lock-alt']" />
    </div>
  </button>
</template>

<script>
import { Currency } from '../utils'
export default {
  props: {
    value: Object,
    showImage: Boolean,
    hidePrice: Boolean,
    sets: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Boolean,
    },
  },
  inject: ['getItemStatus'],
  computed: {
    image() {
      return this.$path('value.product.images.0.url')
    },
    status() {
      if (!this.getItemStatus) return {}
      return this.getItemStatus(this.value.id)
    },
    set() {
      return this.sets
        .filter(s => this.value.sets.includes(s.id))
        .sort((a, b) => a.score - b.score)
        .find(s => s.score >= 0.75)
    },
  },
  filters: {
    Currency,
  },
}
</script>

<style lang="scss">
.shop-product-card {
  border: 1px solid $border-color;
  border-radius: var(--border-radius);

  position: relative;
  cursor: pointer;
  width: 100%;
  padding: 1rem;

  display: flex;
  align-items: center;

  text-align: left;

  &--selected {
    margin: 0;
    border-width: 2px;
    border-color: var(--primary);
    background-color: css-alpha('primary', 0.1);

    .shop-product-card__price {
      opacity: 1;
    }
    &-icon {
      z-index: 1;
      position: absolute;
      top: -10px;
      left: -10px;
      color: white;
      width: 30px;
      height: 30px;
      background: var(--primary);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8em;
    }
  }

  &__content {
    @media (max-width: 1400px) {
      font-size: 0.8em;
    }
  }
  &__properties {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }
  &__property {
    svg {
      margin-right: 5px;
    }
  }

  &[readonly='readonly'],
  &--readonly {
    cursor: not-allowed;
  }

  &__icon {
    z-index: 1;
    position: absolute;
    top: -10px;
    right: -10px;
    color: white;
    width: 25px;
    height: 25px;
    background: var(--primary);
    opacity: 0.9;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.6em;
  }

  &__set {
    opacity: 0.5;
  }

  &__image {
    $size: 50px;

    width: $size;
    height: $size;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    border: 1px solid $border-color;

    background-color: rgba(black, 0.05);

    margin-right: 1rem;

    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: inherit;
      object-position: center;
    }

    svg {
      opacity: 0.3;
    }
  }

  &__name {
    font-weight: bold;
  }

  &__price {
    opacity: 0.5;
    white-space: nowrap;
    transition: opacity 150ms ease-out;
  }
}
</style>
